// CRM 2.0 card bottom message (M1-F10, row M1.34, DC-104).
// One short line followed by an (i) icon; the icon opens a Details pop-up with the
// full text word for word. message = { short, full, tone: note | red | amber | purple }
// from GET /crm2/list (messageShort / messageFull). Nothing is folded or clamped.
import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import Button from "../../../Subcomponents/Button";
import Close from "../../Icons/Close";
import infoSvg from "../../../Assets/Images/Common/info.svg";
import css from "./Crm2Cards.module.css";
import settingsCss from "../Settings/Crm2Settings.module.css";

const TONE_COLOR = { red: "rgba(179,35,24,1)", amber: "#B54708", purple: "#6941C6" };
const btnPrimary = { width: "fit-content", color: "#FFFFFF", backgroundColor: "#155EEF", border: "1px solid #155EEF", fontSize: "1.4rem", lineHeight: "2rem" };

export default function CardMessage({ message }) {
  const [open, setOpen] = useState(false);
  if (!message?.short) return null;
  const more = message.full && message.full !== message.short;
  const icon = more && (
    <button type="button" className={css.minfo} title="View details" aria-label="View details" onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
      i
    </button>
  );
  const body =
    message.tone === "note" || !message.tone ? (
      <p className={css.note}>
        {message.short}
        {icon}
      </p>
    ) : (
      <div className={css.infoLine} style={{ color: TONE_COLOR[message.tone] }}>
        <img src={infoSvg} alt="" />
        <span>
          {message.short}
          {icon}
        </span>
      </div>
    );
  return (
    <>
      {body}
      <Modal open={open} onClose={() => setOpen(false)} sx={{ ".MuiBackdrop-root": { background: "rgba(52, 64, 84, 0.7)" } }} disableAutoFocus>
        <Box className={settingsCss.modalWrapper}>
          <div className={settingsCss.modalHeader}>
            <span>Details</span>
            <span className={settingsCss.modalClose} onClick={() => setOpen(false)} tabIndex={0} role="button" aria-label="Close">
              <Close width="1.2rem" height="1.2rem" />
            </span>
          </div>
          <div className={settingsCss.modalContent}>
            <div style={{ fontSize: "1.5rem", lineHeight: 1.6, color: "#1D2939" }}>{message.full}</div>
          </div>
          <div className={settingsCss.modalFooter}>
            <Button style={btnPrimary} btnName="Close" clicked={() => setOpen(false)} />
          </div>
        </Box>
      </Modal>
    </>
  );
}
